import { getFieldNameWithPrefix } from '@monorepo/shared/componentsV2/fields/fieldUtils';
import { BooleanFormFieldOptions } from 'mapistry-shared';
import React from 'react';
import { ModalFieldWrapper } from '../styled';
import {
  BaseEditGenericFieldFormProps,
  EditGenericFieldForm,
} from './GenericFieldForm/EditGenericFieldForm';
import { ChooseDefaultOptionField } from './shared/ChooseDefaultOptionField';
import { StyledListBuilderField } from './styled';

const defaultValueOptions = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
];

const booleanFieldOptions: BooleanFormFieldOptions = ['Yes', 'No'];

type EditBooleanFieldFormProps = BaseEditGenericFieldFormProps;

// this is rendered within FinalForm so the inputs are managed by it
export function EditBooleanFieldForm({
  ...genericEditFormProps
}: EditBooleanFieldFormProps) {
  const { prefix } = genericEditFormProps;

  const optionsFieldName = getFieldNameWithPrefix('options', prefix);

  return (
    <EditGenericFieldForm {...genericEditFormProps}>
      <ModalFieldWrapper>
        <StyledListBuilderField
          isDisabled
          isRequired
          label="Options"
          name={optionsFieldName}
          initialValue={booleanFieldOptions}
        />
      </ModalFieldWrapper>
      <ChooseDefaultOptionField
        defaultValueOptions={defaultValueOptions}
        prefix={prefix}
      />
    </EditGenericFieldForm>
  );
}
